<template>
  <div v-if="networkResponse && networkResponse.status !== this.STATUSES.SUCCESS && networkResponse.status !== this.STATUSES.TEAPOT"
       class="app-alert-error app-system-alert" id="appAlert"
       role="alert" ref="appAlert">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <div ref="alertMessage" tabindex="-1" v-html="message" class="bannerAlert"> 
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import { mapState } from 'vuex'

export default {
  name: "SystemAlert",
  data() {
    return {
      message: '',
      errors: [
        { code: 400, description: 'Please provide all the required information.' },
        { code: 500, description: 'We are experiencing technical difficulties. Please try your request again.' },
        // {code: 401, description: 'Unknown error 401'},
      ],
    };
  },
  computed: {
    ...mapState([
      'STATUSES',
      'networkResponse',
    ])
  },
  watch: {
    networkResponse() {
      this.setMessage();
    }
  },
  created() {
    this.setMessage();
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.alertMessage) {
        this.$refs.alertMessage.focus();
      }
    })
  },
  methods: {
    // setMessage() {
    //   const found = _.find(this.errors, msg => msg.code === this.networkResponse.status);
    //   this.message = found ? found.description : `${this.networkResponse.message}`;
    // },
    setMessage() {
      if (this.networkResponse && this.networkResponse.status !== 401) {
        const found = _.find(this.errors, msg => msg.code === this.networkResponse.status);
        this.message = found ? found.description : `${this.networkResponse.message}`;
      } 
      else if(this.networkResponse && this.networkResponse.status === 401 ) {
        this.message = this.networkResponse.message || `Unknown error ${this.networkResponse.status}`
      }
      else {
        this.message = `Unknown error ${this.networkResponse ? this.networkResponse.status : ''}`;
      }
    },
  }
}

</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
<style scoped>
 #appAlert >>> a::after {
      content: url(../../public/static/external-link-alt-solid.svg);
      display: inline-block;
      margin: 0 0.35em;
      vertical-align: middle;
      width: 0.9rem;
  }  
  #appAlert >>> div {
  
    font-size: 1rem;
    line-height: 1.5em;
    padding-top: .5em;
    padding-bottom: .5em;
}  
</style>